
<template>
    <div class="container">
        <div class="row" style="width: 70%;">
            <div class="search-bar" style="width: 100%;">
                <form class="search-bar__form " style="width: 100%;">
                    <input type="text" :placeholder="placeholder" v-model="searchInput" class="search-bar__input"/>
                    <button class="search-bar__btn" @click.prevent="Search" @keyup="Search">{{btnText}}
                        <i class="icon-search search-bar__icon"></i>
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'SearchBar',
        mounted(){
            
        },
        props:['placeholder','btnText'],
        data(){
            return{
                searchInput: ''
            }
        },
        methods:{
            Search(){
                if(this.searchInput){
                    this.$emit('applySearch',this.searchInput)
                }
            }
        }
    }
</script>
